import { DropdownItemProps } from 'semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownItem';
import { EPtwStatus, statusMap } from '@relab/alstom-ptw-shared';
import { useTranslation } from 'react-i18next';
import React, { FC, useMemo } from 'react';
import { Dropdown, Header } from 'semantic-ui-react';

type Props = {
  value: EPtwStatus | undefined;
  onChange: (value: EPtwStatus | undefined) => void;
};

export const PtwStatusDropdown: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const optionsForStatusFilter: DropdownItemProps[] = useMemo(() => {
    const options = Object.entries(EPtwStatus)
      .filter(([, value]) => typeof value === 'number')
      .map(([, value]) => ({
        key: value,
        text: t(statusMap[value as unknown as EPtwStatus]?.name),
        value,
      }));

    options.unshift({
      key: -1,
      text: t('Vuoto'),
      value: null,
    });

    return options;
  }, [t]);

  return (
    <>
      <Header as="h5">{t('Status')}</Header>
      <Dropdown
        placeholder={t('Enter the filter.')}
        style={{ width: '100%' }}
        selection
        options={optionsForStatusFilter}
        value={value ?? ''}
        onChange={(e, data) => {
          onChange(data.value as EPtwStatus);
        }}
      />
    </>
  );
};
